import { MetricType, SummaryItemModel } from 'src/app/api/proxy/wearables/wearables-models';
import { ProfileModel } from 'src/app/api/proxy/vitalscore/vitalscore-models';

export function formatGoalSliderValue(
  value?: number | null,
  item?: SummaryItemModel,
  myProfile?: ProfileModel | null,
): string {
  if (!value) {
    return '';
  }
  if (!item || !item.metricType) {
    return value.toFixed(0);
  }
  if (item.metricType === MetricType.Sleep || item.metricType === MetricType.ActiveTime) {
    const hours = Math.floor(value / 60 / 60);
    const minutes = Math.floor((value % 3600) / 60);
    if (hours > 0 && minutes > 0) return `${hours}h ${minutes}m`;
    if (hours > 0) return `${hours}h`;
    return `${minutes}m`;
  }
  if (item.metricType === MetricType.ActivityDistanceSteps && myProfile?.useImperialMeasurements) {
    const feet = value;
    const miles = feet / 5280;
    if (miles >= 1) {
      return `${miles.toFixed(2)} mi`;
    }
    return `${feet.toFixed(0)} ft`;
  }
  return value.toFixed(0);
}

export function filterGoalItems(items: SummaryItemModel[] | null | undefined): SummaryItemModel[] {
  if (!items?.length) {
    return [];
  }
  return items.filter((a) => a.goalBaseValue && a.goalBaseValue > 0);
}
